import { useWeb3React } from '@web3-react/core'
import { SupportedChainId } from 'constants/chains'
import { useIsNftPage } from 'hooks/useIsNftPage'
import { useEffect } from 'react'
import { useDarkModeManager } from 'theme/components/ThemeToggle'

import { darkTheme, lightTheme } from '../colors'

const initialStyles = {
  width: '200vw',
  height: '200vh',
  transform: 'translate(-50vw, -100vh)',
}
const backgroundResetStyles = {
  width: '100vw',
  height: '100vh',
  transform: 'unset',
}

type TargetBackgroundStyles = typeof initialStyles | typeof backgroundResetStyles

const backgroundRadialGradientElement = document.getElementById('background-radial-gradient')
const setBackground = (newValues: TargetBackgroundStyles) =>
  Object.entries(newValues).forEach(([key, value]) => {
    if (backgroundRadialGradientElement) {
      backgroundRadialGradientElement.style[key as keyof typeof backgroundResetStyles] = value
    }
  })

export default function RadialGradientByChainUpdater(): null {
  const { chainId } = useWeb3React()
  const [darkMode] = useDarkModeManager()
  const isNftPage = useIsNftPage()

  // manage background color
  useEffect(() => {
    if (!backgroundRadialGradientElement) {
      return
    }

    if (isNftPage) {
      setBackground(initialStyles)
      backgroundRadialGradientElement.style.background = darkMode
        ? darkTheme.backgroundBackdrop
        : lightTheme.backgroundBackdrop
      return
    }

    switch (chainId) {
      case SupportedChainId.ZKEVM:
      case SupportedChainId.ZKATANA:
      case SupportedChainId.SHIBUYA:
      case SupportedChainId.ASTR: {
        setBackground(backgroundResetStyles)
        if (darkMode) {
          backgroundRadialGradientElement.style.backgroundImage = "url('/images/background_dark.png')"
          backgroundRadialGradientElement.style.backgroundSize = '100%'
        } else {
          const astarColor =
            'radial-gradient(100% 100% at 50% 0%, rgba(205, 232, 255, 0.7) 0%, rgba(222, 230, 249, 0.6536) 49.48%, rgba(255, 255, 255, 0) 100%), #FFFFFF'
          backgroundRadialGradientElement.style.background = astarColor
        }
        break
      }
      default: {
        setBackground(initialStyles)
        const defaultLightGradient =
          'radial-gradient(100% 100% at 50% 0%, rgba(205, 232, 255, 0.7) 0%, rgba(222, 230, 249, 0.6536) 49.48%, rgba(255, 255, 255, 0) 100%), #FFFFFF'
        const defaultDarkGradient = 'linear-gradient(180deg, #202738 0%, #070816 100%)'
        backgroundRadialGradientElement.style.background = darkMode ? defaultDarkGradient : defaultLightGradient
        if (darkMode) {
          backgroundRadialGradientElement.style.backgroundImage = "url('/images/background_dark.png')"
          backgroundRadialGradientElement.style.backgroundSize = '100%'
        }
      }
    }
  }, [darkMode, chainId, isNftPage])
  return null
}
